import React from "react";
import { Link } from "react-router-dom";
import '../../main-component/Landing/landing.css';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const PricingSection = (props) => {
    const { sectiontitleshow = true } = props;

    return (
        <section className={"" + props.pClass}>
            <div className="container">
                {sectiontitleshow && (
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-12">
                            <div className="section-title pricing-title">
                                <h3>Offerta Lancio Kleeo</h3>
                                <h2> Dai valore al tuo tempo. Scegli Kleeo.</h2>
                                <p className="funfact-style">Unisciti ai pionieri che hanno già trasformato la gestione dei loro gatti. Più igiene, meno odori, zero fatica.</p>
                            </div>
                        </div>
                    </div>
                )}

                <div className="row-gap mt-15 align-items-stretch">
                    {/* Kit Essenziale */}
                    <div className="col-12 col-lg-4">
                        <div className="pioneer-card">
                            <div className="card-body">
                                <h4>Kleeo Essenziale</h4>
                                <p className="description">Ideale per chi vuole testare la tecnologia risparmiando al massimo.</p>
                                <div className="price-box">
                                    <span className="old-price">€499</span>
                                    <span className="new-price">€399</span>
                                </div>
                                <p className="price-note">IVA e spedizione incluse</p>
                                <ul className="feature-list">
                                    <li><i className="ti-check"></i> 1x Lettiera Smart Kleeo</li>
                                    <li><i className="ti-check"></i> Set base 20 sacchetti (1 mese)</li>
                                    <li><i className="ti-check"></i> App Tuya inclusa</li>
                                    <li><i className="ti-check"></i> Garanzia 2 anni</li>
                                    <li><i className="ti-check"></i> Spedizione Gratuita</li>

                                    {/*<li><i className="ti-close text-muted"></i> Spedizione Gratuita e Reso 30 giorni.</li>*/}

                                </ul>
                                <Link onClick={ClickHandler} to="/shop" className="btn-pioneer-outline">Acquista ora</Link>
                            </div>
                        </div>
                    </div>

                    {/* Kleeo Pioneer Kit */}
                    <div className="col-12 col-lg-4">
                        <div className="pioneer-card featured">
                            <div className="best-value-tag">PIÙ SCELTO / BEST VALUE</div>
                            <div className="card-body">
                                <h4>Kleeo Pioneer Kit</h4>
                                <p className="description">Tutto il necessario per 3 mesi di relax.</p>
                                <div className="price-box">
                                    <span className="old-price">€529</span>
                                    <span className="new-price">€429</span>
                                </div>
                                <p className="price-note">IVA e spedizione incluse</p>
                                <ul className="feature-list">
                                    <li><i className="ti-check"></i> 1x Lettiera Smart Kleeo</li>
                                    <li><i className="ti-check"></i> <strong>Scorta 6 mesi di sacchetti (120 pz)</strong></li>
                                    <li><i className="ti-check"></i> <strong>2x Confezioni di Sabbia Tecnica Anti-odore</strong></li>
                                    <li><i className="ti-check"></i> App Tuya con monitoraggio salute</li>
                                    <li><i className="ti-check"></i> Spedizione Gratuita</li>
                                    <li><i className="ti-check"></i> Prova di 30 giorni "Soddisfatti o Rimborsati"</li>

                                </ul>
                                <Link onClick={ClickHandler} to="/shop" className="btn-pioneer-main">Diventa un Pionere</Link>
                            </div>
                        </div>
                    </div>

                    {/* Kleeo Double Pack */}
                    <div className="col-12 col-lg-4">
                        <div className="pioneer-card">
                            <div className="card-body">
                                <h4>Kleeo Double Pack</h4>
                                <p className="description">Per case con più gatti o su più piani.</p>
                                <div className="price-box">
                                    <span className="old-price">€998</span>
                                    <span className="new-price">€749</span>
                                </div>
                                <p className="price-note">IVA e spedizione incluse</p>
                                <ul className="feature-list">
                                    <li><i className="ti-check"></i> 2x Lettiere Smart Kleeo</li>
                                    <li><i className="ti-check"></i> Starter Kit sacchetti per entrambe</li>
                                    <li><i className="ti-check"></i> Supporto Priority H24</li>
                                    <li><i className="ti-check"></i> Spedizione Express Gratuita</li>
                                    <li><i className="ti-check"></i> Garanzia Kleeo Care Estesa (3 anni)</li>

                                    <li><i className="ti-star text-warning"></i> <strong>Risparmio Extra di 50€</strong></li>
                                </ul>
                                <Link onClick={ClickHandler} to="/shop" className="btn-pioneer-outline">Ordina ora</Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-center mt-4">
                    <p className="trust-footer">Pagamento sicuro al 100% • Consegna in 48h • 2 Anni di Garanzia Italiana</p>
                </div>
            </div>
        </section>
    );
}

export default PricingSection;
